/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Unauthorizedfunds2Inputs */

const en_usermanagement_permissions_unauthorizedfunds2 = /** @type {(inputs: Usermanagement_Permissions_Unauthorizedfunds2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are unauthorized to manage the following funds`)
};

/**
* | output |
* | --- |
* | "You are unauthorized to manage the following funds" |
*
* @param {Usermanagement_Permissions_Unauthorizedfunds2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_unauthorizedfunds2 = /** @type {((inputs?: Usermanagement_Permissions_Unauthorizedfunds2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Unauthorizedfunds2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_unauthorizedfunds2(inputs)
});
export { usermanagement_permissions_unauthorizedfunds2 as "userManagement_permissions_unauthorizedFunds" }